import React, { useEffect, useState } from 'react';
import UploadDropzone from './UploadDropzone';

const CategoryEditForm = ({ value, onChangeFile, previewUrl, progress, onSubmit, submitting, onCancel }) => {
  const [form, setForm] = useState(value || {});
  useEffect(()=> setForm(value || {}), [value]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f)=> ({ ...f, [name]: type==='checkbox' ? checked : value }));
  };

  return (
    <form onSubmit={(e)=>{e.preventDefault(); onSubmit(form);}} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Título</label>
        <input name="title" value={form.title || ''} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#D67441]" required />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Slug (ex.: vinilico)</label>
        <input name="slug" value={form.slug || ''} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#D67441]" required />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Subtítulo</label>
        <input name="subtitle" value={form.subtitle || ''} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#D67441]" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
        <textarea name="description" value={form.description || ''} onChange={handleChange} rows={3} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#D67441]" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Benefícios (separe por vírgulas)</label>
        <input name="benefits" value={Array.isArray(form.benefits) ? form.benefits.join(', ') : (form.benefits || '')} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#D67441]" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Ideal para</label>
        <input name="idealFor" value={form.idealFor || ''} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#D67441]" />
      </div>

      <UploadDropzone label="Imagem da Categoria" onFileSelected={(f)=> onChangeFile(f)} previewUrl={previewUrl} progress={progress} />

      <div className="flex gap-2 justify-end">
        <button type="button" onClick={onCancel} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50">Cancelar</button>
        <button type="submit" disabled={submitting} className="px-4 py-2 rounded-lg bg-[#D67441] text-white font-bold hover:bg-[#B85A35] disabled:opacity-70">{submitting ? 'Salvando...' : 'Salvar'}</button>
      </div>
    </form>
  );
};

export default CategoryEditForm; 